var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthorization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4964_28747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 4.99967C10.9173 4.99967 11.6673 5.74967 11.6673 6.66634C11.6673 7.58301 10.9173 8.33301 10.0007 8.33301C9.08398 8.33301 8.33398 7.58301 8.33398 6.66634C8.33398 5.74967 9.08398 4.99967 10.0007 4.99967ZM10.0007 12.4997C12.2507 12.4997 14.834 13.5747 15.0007 14.1663V14.9997H5.00065V14.1747C5.16732 13.5747 7.75065 12.4997 10.0007 12.4997ZM10.0007 3.33301C8.15898 3.33301 6.66732 4.82467 6.66732 6.66634C6.66732 8.50801 8.15898 9.99967 10.0007 9.99967C11.8423 9.99967 13.334 8.50801 13.334 6.66634C13.334 4.82467 11.8423 3.33301 10.0007 3.33301ZM10.0007 10.833C7.77565 10.833 3.33398 11.9497 3.33398 14.1663V16.6663H16.6673V14.1663C16.6673 11.9497 12.2257 10.833 10.0007 10.833Z",
    fill: "#2990FB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4964_28747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorization);
export default __webpack_public_path__ + "static/media/authorization.1d6531dc7ca0f2e88a194e8dd714d4bb.svg";
export { ForwardRef as ReactComponent };